import { Box, Button, Flex, Icon, Text } from '@podiumhq/design-system';
import PropTypes from 'prop-types';

const PaymentRequest = ({ amount }) => (
  <Flex flexDir="column" alignItems="center" justifyContent="center">
    <Flex
      alignItems="center"
      bg="green.base"
      borderRadius="14px"
      height="48px"
      justifyContent="center"
      w="48px"
    >
      <Icon type="Store" boxSize={8} />
    </Flex>
    <Text
      color="black.base"
      fontSize="lg"
      fontWeight="semibold"
      mb="16px"
      mt="16px"
      textAlign="center"
    >
      ${amount}
    </Text>
    <Box w="100%" h="11px" bg="#F2F5FA" borderRadius="16px" />
    <Button
      colorScheme="tertiary"
      mt="16px"
      size="md"
      variant="primary"
      width="100%"
    >
      Pay now
    </Button>
  </Flex>
);

PaymentRequest.propTypes = {
  amount: PropTypes.string.isRequired,
};

export default PaymentRequest;
